import { PropsWithChildren, ReactElement } from 'react';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import dynamic from 'next/dynamic';

import styles from './counterToBadge.module.scss';

dayjs.extend(relativeTime);

// 🚨 MIND THE GAP 🚨
// this component contains parts which might give hydration errors,
// due to mismatch in server time and browser time
export const CounterToBadge = ({
  endsAt,
}: PropsWithChildren<{ endsAt: string }>): ReactElement | null => {
  const now = dayjs();
  const endsAtTime = dayjs(endsAt);

  return now < endsAtTime ? (
    <span className={styles.counterToBadge} data-testid="counter">
      ENDS IN {now.to(endsAtTime, true)}
    </span>
  ) : null;
};

export const DynamicCounterToBadge = dynamic(
  () =>
    import('@/common/components/CounterToBadge/CounterToBadge').then(
      (module) => module.CounterToBadge,
    ),
  { ssr: false },
);

export default DynamicCounterToBadge;
